import { graphql } from "@/lib/gql/__generated__";

export const HotelList_CompanyTopPage_Query = graphql(/* GraphQL */ `
	query HotelList {
		hotelList {
			id
			hotels {
				id
				...HotelHotelCard
			}
		}
	}
`);
